var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightIconDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#CCCCCC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8627 12.7851C16.5182 13.2167 15.889 13.2873 15.4573 12.9428L10.3761 8.88698C9.94441 8.54244 9.87379 7.91323 10.2183 7.48158C10.5629 7.04994 11.1921 6.97932 11.6237 7.32386L16.705 11.3797C17.1366 11.7242 17.2072 12.3534 16.8627 12.7851Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2099 16.7183C9.87142 16.2818 9.95081 15.6537 10.3872 15.3152L15.47 11.373C15.9065 11.0346 16.5346 11.114 16.8731 11.5504C17.2116 11.9868 17.1322 12.615 16.6958 12.9534L11.6129 16.8956C11.1765 17.2341 10.5484 17.1547 10.2099 16.7183Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.1225C7 11.5702 7.44772 11.1225 8 11.1225H15C15.5523 11.1225 16 11.5702 16 12.1225C16 12.6748 15.5523 13.1225 15 13.1225H8C7.44772 13.1225 7 12.6748 7 12.1225Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIconDisabled);
export default __webpack_public_path__ + "static/media/ArrowRightIconDisabled.e0333a1f8a3fa24e0e5bf4100b2d8ab5.svg";
export { ForwardRef as ReactComponent };